import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SettlementComponent } from './settlement.component';

@Injectable()
export class CanDeactivateSettlement<T extends SettlementComponent> {
    constructor() {}

    canDeactivate(
        component: T,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (component.settling) {
            return component.settlingBackActionCheck();
        }
        return true;
    }
}
